export const getOrientationType = () => {
    return window.screen?.orientation?.type?.includes('landscape') ? 'landscape' : 'portrait';
};